<template>
<div class="col-sm-12 mb-3 inlineform text-center">	    
    <div>
    <div class="exportcheckpadding5">
    <div class="headermain mb-5 mt-5">
        <nav class="navbar navbar-expand-xl" id="navbar_top" style="display: block;">
            <div class="container">
                <div class="row w-100" v-if="Group.name">
                    <div class="col-lg-12 col-xl-12 mb-3 text-center qr-code-text"> {{Group.name}}</div>
                    <div class="col-lg-12 col-xl-12 mb-3 text-center">
                        <img :src="getGroupQRCode(Group)" style="max-height:300px;"/>
                    </div> 
                    <div class="col-lg-12 col-xl-12 mb-3 text-center print_btn">
                        <a class="mt-4 btn btn-sm btn-primary" @click="PrintReport()">Print</a>    
                    </div>           
                </div>
            </div>
        </nav>
    </div>
  </div>
</div>          	
</div>
</template>
<script>
  import Axios from "axios";
  import $ from "jquery";
  

  export default {
    components: {  },
    data() {
      return {
        ShowLoader: false,
        GroupId: 0,
        Group: {},
        QRCodeEndpoint: Endpoints.QR.Generate + "?content=",
      };
    },
    mounted() {
      document.title = pbx_SiteTitle + " - Group QR Code";
      this.GroupId = this.$route.params.Id;
      setTimeout(() => {
        this.GetGroupDetail();
      }, 1000);
    },
    methods: {
      PrintReport() {
        window.print();
      },
      GetGroupDetail() {
      this.ShowLoader = true;
      Axios.post(Endpoints.Assets.Group.Get, {
        token: localStorage.getItem("token"),
        Group_id: this.GroupId,
      }).then((Response) => {
        this.ShowLoader = false;
        if (Response.data.success) {
          this.Group = Response.data.record;
        }
      });
    },
      getGroupQRCode(group){
        let data = {'id' :group.id, 'type':'group'};
        var qrurl = this.QRCodeEndpoint + btoa(JSON.stringify(data));
      	return qrurl;
      },
    },

  };
</script>
<style scoped>
.qr-code-text{
  font-size: 14px;
  font: bold;
}
  @media print {
    .print_btn {
      display: none;
    }
  }
</style>
